import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatRand, displayPrice, isSoldOut, resolveImageUrl } from "../lib/api";

const CatalogPage = ({ category, title, edgeCapsule, columns = 2 }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: { category } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="catalog-page" data-testid={`${category}-page`}>
      {/* Print registration marks */}
      <span className="catalog-mark catalog-mark-tl" aria-hidden="true">⊕</span>
      <span className="catalog-mark catalog-mark-tr" aria-hidden="true">⊕</span>
      <span className="catalog-mark catalog-mark-bl" aria-hidden="true">⊕</span>
      <span className="catalog-mark catalog-mark-br" aria-hidden="true">⊕</span>

      {/* Vertical edge labels */}
      <div className="catalog-side catalog-side-top" data-testid="catalog-edge-top">CAPE TOWN, ZA</div>
      <div className="catalog-side catalog-side-mid" data-testid="catalog-edge-mid">SWENKVILLE.COM</div>
      <div className="catalog-side catalog-side-bot" data-testid="catalog-edge-bot">{edgeCapsule}</div>

      {/* Title */}
      <div className="text-center pt-16 sm:pt-24 pb-12 sm:pb-20" data-testid={`${category}-title`}>
        <h1 className="font-blackletter" style={{ fontSize: "clamp(4.5rem, 14vw, 11rem)" }}>
          {title}
        </h1>
      </div>

      {/* Product grid */}
      <div className="catalog-grid-wrap">
        {loading ? null : products.length === 0 ? (
          <div className="text-sm text-black/40 text-center pb-32">No pieces yet.</div>
        ) : (
          <div
            className="catalog-grid"
            style={{ "--catalog-cols": columns }}
            data-testid={`${category}-grid`}
          >
            {products.map((p, i) => {
              const soldOut = isSoldOut(p);
              return (
              <Link
                key={p.id}
                to={`/product/${p.id}`}
                className="catalog-card group fade-up"
                style={{ animationDelay: `${i * 80}ms` }}
                data-testid={`${category}-card-${p.id}`}
              >
                <div className="catalog-img-wrap relative">
                  {soldOut && (
                    <span className="tag-sale" data-testid={`${category}-soldout-tag-${p.id}`}>Sold Out</span>
                  )}
                  <img
                    src={resolveImageUrl(p.images?.[0])}
                    alt={p.name}
                    className="catalog-img"
                    loading="lazy"
                    style={soldOut ? { opacity: 0.5 } : undefined}
                  />
                </div>
                <div className="catalog-card-meta">
                  <div className="catalog-card-name" data-testid={`${category}-name-${p.id}`}>{p.name}{soldOut ? " — Sold Out" : ""}</div>
                  <div className="catalog-card-price" data-testid={`${category}-price-${p.id}`}>{formatRand(displayPrice(p))}</div>
                </div>
              </Link>
              );
            })}
          </div>
        )}
      </div>

      {/* CMYK + neutral color bar */}
      <div className="catalog-color-bar" aria-hidden="true">
        <span style={{ background: "#00aeef" }} />
        <span style={{ background: "#ec008c" }} />
        <span style={{ background: "#fff200" }} />
        <span style={{ background: "#0a0a0a" }} />
        <span className="catalog-color-bar-gap" />
        <span style={{ background: "#0a0a0a" }} />
        <span style={{ background: "#2a2a2a" }} />
        <span style={{ background: "#5a5a5a" }} />
        <span style={{ background: "#9a9a9a" }} />
        <span style={{ background: "#c8c8c8" }} />
        <span style={{ background: "#ececec" }} />
      </div>
    </div>
  );
};

export default CatalogPage;
